import React from 'react'
// hocs
import withAction from '../withAction'
// hooks
import { useModalData, useRefetchTree, useShowModal } from 'hooks'
// components
import { Tab } from '@mui/material'
import { DrawerModal, Tabs } from 'components/UI'
import { LoaderWithOverlay } from 'components/UI/Loader'
import { PlanActionActionsMenu } from 'components/CTAs'
// view components
import DetailsSection from './components/DetailsSection'
import CompleteAction from './components/DetailsSection/components/CompleteAction'
import ActionReviewsList from './components/ReviewsList'
import ActionResourcesList from './components/ResourcesList'
import ActionActivitiesList from './components/ActivitiesList'
import CompleteReview from 'components/Modals/PlanItems/components/CompleteReview'
import ApproveReview from 'components/Modals/PlanItems/components/ApproveReview'
import SetColorModal from 'components/Modals/SetColorModal'
// constants
import { ENTITIES, Modals } from 'constants/index'
// themes
import { CloseIcon } from 'components/UI/Icons'
import { Header, OpenIcon, SubHeader, Wrapper } from 'components/Modals/PlanItems/styles'
// utils
import get from 'lodash/get'
// context
import { ActionContext } from 'context'
// types
import { LogEntityTypes } from 'types/graphql'

const PAPER_PROPS = {
  style: {
    overflowY: 'visible'
  }
}

const ActionMinimizedModal = () => {
  const {
    modalData: { isOpen: isReview }
  } = useModalData({ modalType: Modals.REVIEW_CREATE_MODAL })

  const { showModal } = useShowModal({ modalType: Modals.ACTION_FULL_MODAL })

  const { hideModal, modalData } = useModalData({ modalType: Modals.ACTION_MINIMIZED_MODAL })

  const [tab, setTab] = React.useState(0)

  const { entity, isLoading, update, plan } = React.useContext(ActionContext)

  const { isOpen, hideMenu } = modalData

  const openFullModal = () => showModal()

  const handleSetTab = (_, value) => setTab(value)

  useRefetchTree()

  return (
    <DrawerModal
      width={'600px'}
      isOpen={isOpen && !isReview}
      hideModal={hideModal}
      PaperProps={PAPER_PROPS}>
      <Header>
        {!isLoading && (
          <>
            <span>{get(entity, 'description')}</span>
            {!hideMenu && <OpenIcon onClick={openFullModal} />}
            <CloseIcon onClick={hideModal} />
          </>
        )}
      </Header>

      <LoaderWithOverlay isLoading={isLoading} />

      {!isLoading && entity && (
        <>
          <SubHeader>
            {!hideMenu && !plan.locked && <PlanActionActionsMenu hideParent={hideModal} />}
            <Tabs value={tab} onChange={handleSetTab} indicatorColor='primary' textColor='primary' variant={null}>
              <Tab label='Details' />
              <Tab label='Activity' />
              <Tab label='Resources' />
              <Tab label='Reviews' />
            </Tabs>
          </SubHeader>
          {tab === 0 && (
            <>
              <CompleteAction entity={entity} update={update} />
              <CompleteReview entity={{ ...entity, entityType: ENTITIES.PLAN_ACTION }} />
              <ApproveReview entity={{ ...entity, entityType: ENTITIES.PLAN_ACTION }} />
              <Wrapper>
                <DetailsSection
                  entity={{ ...entity, entityType: LogEntityTypes.Action }}
                  hideModal={hideModal}
                  modalData={modalData}
                />
              </Wrapper>
            </>
          )}
          {tab === 1 && <ActionActivitiesList />}
          {tab === 2 && <ActionResourcesList />}
          {tab === 3 && <ActionReviewsList />}
        </>
      )}
      <SetColorModal />
    </DrawerModal>
  )
}

export default withAction(ActionMinimizedModal)
